// Утилиты для Form2

import { parseDecimal } from '../../../utils/decimalUtils';

// Функции валидации для дробных чисел
export const validatePolnota = (value, yarusNumber) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num > 1.3) return false; // Максимум 1.3
  
  // Валидация в зависимости от номера яруса
  if (yarusNumber === 1) {
    // 1 ярус: от 0.00 до 1.30
    return num >= 0.00 && num <= 1.30;
  } else if (yarusNumber === 2 || yarusNumber === 3) {
    // 2-3 ярусы: от 0.3 до 1.30
    return num >= 0.3 && num <= 1.30;
  }
  
  return true;
};

export const validateZapas = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num < 0) return false;
  if (num >= 100000000) return false; // 8 знаков до запятой
  return true;
};

export const validatePositiveZapas = (value) => {
  if (!value) return false;
  const num = parseDecimal(value);
  if (isNaN(num)) return false;
  if (num <= 0) return false;
  if (num >= 100000000) return false;
  return true;
};

const CNL_HANDBOOK_ID = 16; // Справочник «Целевое назначение лесов»
const PROTECTIVE_FORESTS_NAME = 'защитные леса';

/**
 * П. 2.8: при выборе целевого назначения лесов «Защитные леса» поле «Категория
 * защитных лесов» (kzl) становится обязательным. cnlValue — выбранный id записи
 * справочника 16 (как хранится в displayData.cnl), handbooks — список справочников.
 */
export const isProtectiveForestsCnl = (cnlValue, handbooks) => {
  if (!cnlValue || !Array.isArray(handbooks)) return false;
  const handbook = handbooks.find(h => h.id === CNL_HANDBOOK_ID);
  if (!handbook || !handbook.references) return false;
  const selected = handbook.references.find(r => r.id.toString() === String(cnlValue));
  return !!selected && String(selected.name || '').trim().toLowerCase() === PROTECTIVE_FORESTS_NAME;
};

const KATZEM_HANDBOOK_ID = 6; // Справочник «Категории земель лесного фонда»
const FOREST_COVERED_LAND_NAME = 'покрытые лесной растительностью';

// То же условие, что в серверной проверке карточки: запись 14 справочника 6.
export const isForestCoveredLandCategory = (katzemValue) => String(katzemValue ?? '') === '14';

/**
 * Таблица «Характеристика насаждения по ярусам» обязательна только на землях,
 * покрытых лесной растительностью. Выбрана другая категория земель — гарь,
 * вырубка, болото и т.д. — насаждения на участке нет, и таблица целиком
 * становится необязательной. Пока категория не выбрана, ничего не меняется.
 * katzemValue — выбранный id записи справочника 6 (как в displayData.katzem).
 */
export const isNonForestLandCategory = (katzemValue, handbooks) => {
  if (!katzemValue || !Array.isArray(handbooks)) return false;
  const handbook = handbooks.find(h => h.id === KATZEM_HANDBOOK_ID);
  if (!handbook || !handbook.references) return false;
  const selected = handbook.references.find(r => r.id.toString() === String(katzemValue));
  if (!selected) return false;
  return String(selected.name || '').trim().toLowerCase() !== FOREST_COVERED_LAND_NAME;
};

// Функции форматирования
export const formatPolnota = (value) => {
  if (!value || value === '') return '0.00';
  const num = parseDecimal(value);
  if (isNaN(num)) return '0.00';
  
  // Ограничиваем максимум до 1.3
  if (num > 1.3) {
    return '1.30';
  }
  
  return num.toFixed(2);
};

export const formatZapas = (value) => {
  if (!value || value === '') return '0.00';
  const num = parseDecimal(value);
  if (isNaN(num)) return '0.00';
  
  // Ограничиваем до 8 знаков до запятой
  if (num >= 100000000) {
    return '99999999.00';
  }
  
  return num.toFixed(2);
};

// Форматирование для характеристик пород
export const formatVozrast = (value) => {
  if (!value || value === '') return '';
  const num = parseInt(value);
  if (isNaN(num)) return '';
  return Math.min(Math.max(num, 0), 999).toString();
};

export const formatVysota = (value) => {
  if (!value || value === '') return '';
  const num = parseDecimal(value);
  if (isNaN(num)) return '';
  return Math.min(Math.max(num, 0), 999.9).toFixed(1);
};

export const formatDiametr = (value) => {
  if (!value || value === '') return '';
  const num = parseDecimal(value);
  if (isNaN(num)) return '';
  return Math.min(Math.max(num, 0), 9999.9).toFixed(1);
};

